export const baseURL = `/assets/`

export const financialStatementsData = {
  '2019': [
    {
      name: 'First Quarter',
      url: 'SFL%20Finance%20Reports%2F2019%2F2019%20-%20Q1.pdf',
    },
    {
      name: 'Second Quarter',
      url: 'SFL%20Finance%20Reports%2F2019%2F2019%20-%20Q2.pdf',
    },
    {
      name: 'Third Quarter',
      url: 'SFL%20Finance%20Reports%2F2019%2F2019%20-%20Q3.pdf',
    },
    {
      name: 'Annual Financial Statements',
      url: 'SFL%20Finance%20Reports%2F2019%2F2019%20-%20Annual%20Report.pdf',
    },
  ],
  '2020': [
    {
      name: 'First Quarter',
      url: 'SFL%20Finance%20Reports%2F2020%2F2020%20-%20Q1.pdf',
    },
    {
      name: 'Second Quarter',
      url: 'SFL%20Finance%20Reports%2F2020%2F2020%20-%20Q2.pdf',
    },
    {
      name: 'Third Quarter',
      url: 'SFL%20Finance%20Reports%2F2020%2F2020%20-%20Q3.pdf',
    },
    {
      name: 'Annual Financial Statements',
      url: 'SFL%20Finance%20Reports%2F2020%2F2020%20-%20Annual%20Report.pdf',
    },
    {
      name: 'Annual Board Report',
      url: 'SFL%20Finance%20Reports/2020/BoardAnnualReport2020.pdf',
    },
  ],
  '2021': [
    {
      name: 'First Quarter',
      url: 'SFL%20Finance%20Reports%2F2021%2F2021%20-%20Q1.pdf',
    },
    {
      name: 'Second Quarter',
      url: 'SFL%20Finance%20Reports%2F2021%2F2021%20-%20Q2.pdf',
    },
    {
      name: 'Third Quarter',
      url: 'SFL%20Finance%20Reports%2F2021%2F2021%20-%20Q3.pdf',
    },
    {
      name: 'Annual Financial Statements',
      url: 'SFL%20Finance%20Reports%2F2021%2F2021%20-%20Annual%20Report.pdf',
    },
    {
      name: 'Annual Board Report',
      url: 'SFL%20Finance%20Reports/2021/BoardAnnualReport2021.pdf',
    },
  ],
  '2022': [
    {
      name: 'First Quarter',
      url: 'SFL%20Finance%20Reports%2F2022%2F2022%20-%20Q1.pdf',
    },
    {
      name: 'Second Quarter',
      url: 'SFL%20Finance%20Reports%2F2022%2F2022%20-%20Q2.pdf',
    },
    {
      name: 'Third Quarter',
      url: 'SFL%20Finance%20Reports%2F2022%2F2022%20-%20Q3.pdf',
    },
    {
      name: 'Annual Financial Statements',
      url: 'SFL%20Finance%20Reports%2F2022%2F2022%20-%20Annual%20Report.pdf',
    },
    {
      name: 'Annual Board Report',
      url: 'SFL%20Finance%20Reports/2022/BoardAnnualReport2022.pdf',
    },
  ],
  '2023': [
    {
      name: 'First Quarter',
      url: 'SFL%20Finance%20Reports%2F2023%2F2023%20-%20Q1.pdf',
    },
    {
      name: 'Second Quarter',
      url: 'SFL%20Finance%20Reports%2F2023%2F2023%20-%20Q2.pdf',
    },
    {
      name: 'Third Quarter',
      url: 'SFL%20Finance%20Reports%2F2023%2F2023%20-%20Q3.pdf',
    },
    {
      name: 'Annual Financial Statements',
      url: 'SFL%20Finance%20Reports/2023/AnnualFinancialReport2023.pdf',
    },
    {
      name: 'Annual Board Report',
      url:
        'SFL%20Finance%20Reports/2023/2023%20-%20Board%20Annual%20Report.pdf',
    },
  ],
  '2024': [
    {
      name: 'First Quarter',
      url: 'SFL%20Finance%20Reports/2024/FS_SFL_Q1_2024_Audited.pdf',
    },
    {
      name: 'Second Quarter',
      url: 'SFL%20Finance%20Reports/2024/FS_SFL_Q2_2024_Audited.pdf',
    },
    {
      name: 'Third Quarter',
      url: 'SFL%20Finance%20Reports/2024/FS_SFL_Q3_2024_Audited.pdf',
    },
    {
      name: 'Annual Financial Statements',
      url: 'SFL%20Finance%20Reports/2024/AnnualFinancialReport2024.pdf',
    },
    {
      name: 'Annual Board Report',
      url: 'SFL%20Finance%20Reports/2024/BoardAnnualReport2024.pdf',
    },
  ],
  '2025': [
    {
      name: 'First Quarter',
      url: 'SFL%20Finance%20Reports/2025/FS_SFL_Q1_2025_Audited.pdf',
    },
    {
      name: 'Second Quarter',
      url: 'SFL%20Finance%20Reports/2025/FS_SFL_Q2_2025_Audited.pdf',
    },
    {
      name: 'Third Quarter',
      url: 'SFL%20Finance%20Reports/2025/FS_SFL_Q3_2025_Audited.pdf',
    },
    {
      name: 'Annual Financial Statements',
      url: 'SFL%20Finance%20Reports/2025/AnnualFinancialReport2025.pdf',
    },
    {
      name: 'Annual Board Report',
      url: 'SFL%20Finance%20Reports/2025/BoardAnnualReport2025.pdf',
    },
  ],
  '2026': [
    {
      name: 'First Quarter',
      url: 'SFL%20Finance%20Reports/2026/FS_SFL_Q1_2026.pdf',
    },
    {
      name: 'Second Quarter',
      url: 'SFL%20Finance%20Reports/2026/FS_SFL_Q2_2026.pdf',
    },
  ],
}
